var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notEmpty)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.mailtoHandler}},[_vm._t("default",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.encoded)}})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }